import {CustomFileData, formatBytes} from '@/shared/utils'

const countLabel = (n: number) => `${n.toLocaleString()} ${n === 1 ? 'item' : 'items'}`

const totalSize = (files: CustomFileData[]) => files.reduce((sum, f) => sum + (f.size ?? 0), 0)

/**
 * The file browser's status line, as in a desktop file manager: "12 items · 3.4 GB", or
 * "3 of 12 selected · 800 MB" while there is a selection. The size is left out when it is zero,
 * e.g. for a folder holding only subfolders, whose listing rows carry no size.
 */
export function describeFolderStatus(
  entries: CustomFileData[],
  selected: CustomFileData[]
): string {
  const counted = selected.length > 0 ? selected : entries
  const count =
    selected.length > 0
      ? `${selected.length.toLocaleString()} of ${countLabel(entries.length)} selected`
      : countLabel(entries.length)
  const bytes = totalSize(counted)
  return bytes > 0 ? `${count} · ${formatBytes(bytes, 1)}` : count
}
